import { useEffect } from "react";
import About from "@/components/site/About";
import Clients from "@/components/site/Clients";

export default function AboutPage() {
    useEffect(() => {
        document.title = "About — MIDI Pictures";
    }, []);
    return (
        <main data-testid="about-page" className="bg-black pt-32">
            <About />
            <Clients />
        </main>
    );
}
